export const RU = {
  startsWith: 'Начинается с',
  contains: 'Содержит',
  notContains: 'Не содержит',
  endsWith: 'Заканчивается на',
  equals: 'Равно',
  notEquals: 'Не равно',
  noFilter: 'Без фильтра',
  lt: 'Меньше чем',
  lte: 'Меньше или равно',
  gt: 'Больше чем',
  gte: 'Больше или равно',
  is: 'Равно',
  isNot: 'Не равно',
  before: 'До',
  after: 'После',
  dateIs: 'Дата равна',
  dateIsNot: 'Дата не равна',
  dateBefore: 'Дата до',
  dateAfter: 'Дата после',
  clear: 'Очистить',
  apply: 'Применить',
  matchAll: 'Соответствует всем',
  matchAny: 'Соответствует любому',
  addRule: 'Добавить правило',
  removeRule: 'Удалить правило',
  accept: 'Да',
  reject: 'Нет',
  choose: 'Выбрать',
  upload: 'Загрузить',
  cancel: 'Отмена',
  completed: 'Завершено',
  pending: 'В ожидании',
  fileSizeTypes: ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ЙБ'],
  dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
  chooseYear: 'Выбрать год',
  chooseMonth: 'Выбрать месяц',
  chooseDate: 'Выбрать дату',
  prevDecade: 'Предыдущее десятилетие',
  nextDecade: 'Следующее десятилетие',
  prevYear: 'Предыдущий год',
  nextYear: 'Следующий год',
  prevMonth: 'Предыдущий месяц',
  nextMonth: 'Следующий месяц',
  prevHour: 'Предыдущий час',
  nextHour: 'Следующий час',
  prevMinute: 'Предыдущая минута',
  nextMinute: 'Следующая минута',
  prevSecond: 'Предыдущая секунда',
  nextSecond: 'Следующая секунда',
  am: 'дп',
  pm: 'пп',
  today: 'Сегодня',
  weekHeader: 'Нед',
  firstDayOfWeek: 0,
  dateFormat: 'dd.mm.yy',
  weak: 'Слабый',
  medium: 'Средний',
  strong: 'Сильный',
  passwordPrompt: 'Введите пароль',
  fileChosenMessage: 'Файлов',
  noFileChosenMessage: 'Файл не выбран',
  emptyFilterMessage: 'Результаты не найдены',
  searchMessage: 'Доступно {0} результатов',
  selectionMessage: 'Выбрано {0} элементов',
  emptySelectionMessage: 'Элементы не выбраны',
  emptySearchMessage: 'Результаты не найдены',
  emptyMessage: 'Нет данных',
  aria: {
    trueLabel: 'Истина',
    falseLabel: 'Ложь',
    nullLabel: 'Не выбрано',
    star: '1 звезда',
    stars: '{star} звезд',
    selectAll: 'Все элементы выбраны',
    unselectAll: 'Все элементы сняты',
    close: 'Закрыть',
    previous: 'Предыдущий',
    next: 'Следующий',
    navigation: 'Навигация',
    scrollTop: 'Прокрутить вверх',
    moveTop: 'Переместить в начало',
    moveUp: 'Переместить вверх',
    moveDown: 'Переместить вниз',
    moveBottom: 'Переместить в конец',
    moveToTarget: 'Переместить в целевой список',
    moveToSource: 'Переместить в исходный список',
    moveAllToTarget: 'Переместить все в целевой список',
    moveAllToSource: 'Переместить все в исходный список',
    pageLabel: 'Страница {page}',
    firstPageLabel: 'Первая страница',
    lastPageLabel: 'Последняя страница',
    nextPageLabel: 'Следующая страница',
    prevPageLabel: 'Предыдущая страница',
    previousPageLabel: 'Предыдущая страница',
    rowsPerPageLabel: 'Строк на странице',
    jumpToPageDropdownLabel: 'Перейти к странице (выпадающий список)',
    jumpToPageInputLabel: 'Перейти к странице (ввод)',
    selectRow: 'Строка выбрана',
    unselectRow: 'Выбор строки снят',
    expandRow: 'Строка развернута',
    collapseRow: 'Строка свернута',
    showFilterMenu: 'Показать меню фильтра',
    hideFilterMenu: 'Скрыть меню фильтра',
    filterOperator: 'Оператор фильтра',
    filterConstraint: 'Условие фильтра',
    editRow: 'Редактировать строку',
    saveEdit: 'Сохранить изменения',
    cancelEdit: 'Отменить редактирование',
    listView: 'Вид списка',
    gridView: 'Вид сетки',
    slide: 'Слайд',
    slideNumber: 'Слайд {slideNumber}',
    zoomImage: 'Увеличить изображение',
    zoomIn: 'Увеличить',
    zoomOut: 'Уменьшить',
    rotateRight: 'Повернуть вправо',
    rotateLeft: 'Повернуть влево',
    listLabel: 'Список опций',
    selectColor: 'Выбрать цвет',
    removeLabel: 'Удалить',
    browseFiles: 'Выбрать файлы',
    maximizeLabel: 'Развернуть',
    minimizeLabel: 'Свернуть'
  }
};
